module.exports = __webpack_public_path__ + "img/1.bc8441f6.png";